<template>
  <div
    class="card mx-3 mt-3 mb-3"
  >
    <div class="card-body d-flex justify-content-between align-items-center py-3">
      <div>
        <div class="fw-semibold">
          <i class="fa-solid fa-tags me-2 text-success" />
          {{ $t('_promotion.Promotion System') }}
        </div>
        <div class="text-muted" style="font-size: 13px;">
          {{ is_enabled ? $t('_promotion.Promotion enabled') : $t('_promotion.Promotion disabled') }}
        </div>
      </div>
      <div class="form-check form-switch m-0">
        <input
          id="promotionEnabledSwitch"
          class="form-check-input"
          type="checkbox"
          role="switch"
          style="width: 3rem; height: 1.5rem;"
          :checked="is_enabled"
          :disabled="saving"
          @change="onToggle($event.target.checked)"
        >
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { Setting } from '@/services/endpoint/setting.service';

export default {
  name: 'PromotionSettingsCard',
  // ค่าเริ่มต้นมาจากหน้า settings (GET ครั้งเดียว) — card ไม่ fetch เอง ทำหน้าที่ PUT toggle เท่านั้น
  props: {
    initialEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      is_enabled: this.initialEnabled,
      saving: false
    };
  },
  methods: {
    async onToggle(value) {
      const prev = this.is_enabled;
      this.is_enabled = value; // optimistic — UI flips ทันที
      this.saving = true;
      try {
        await Setting.update({ promotion_is_enabled: value ? 1 : 0 });
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Promotion settings updated.'));
      } catch (err) {
        this.is_enabled = prev; // revert (reactive → checkbox เด้งกลับ) เช่นกรณีไม่มีสิทธิ์ setting_manage
        this.$toast.warn(err?.response?.data?.message || this.$t('Failed to update settings'));
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
